import {
  ISearchQuery,
  IInboxNotes,
} from '@llws/platform-shared-types/types/api/lead-warehouse';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IBaseFieldConfig } from '../interfaces';
import { TUpdateLead } from '../types/t-inbox-lead';

export const get = async (filter: ISearchQuery) => adminRequest.post(`/v0/lead-warehouse-api/leads/_search`, filter);

export const getById = async (id: string) => adminRequest.get(
  `/v0/lead-warehouse-api/leads/${id}`,
);

export const getExport = async (filter: ISearchQuery & {fields: IBaseFieldConfig}, queryString: string) => adminRequest.post(`/v0/lead-warehouse-api/leads/_search${queryString}`, filter);

export const getLeadNotes = async (payload: Record<string, string>) => adminRequest.get(
  `/v0/lead-warehouse-api/notes/${payload.id}?sort=timestamp:${payload.orderDir}`,
);

export const postNotes = async (payload: IInboxNotes) => adminRequest.post(`/v0/lead-warehouse-api/notes/${payload.relId}/prospect`, payload);

export const deleteNotes = async (id: string) => adminRequest.delete(`/v0/lead-warehouse-api/notes`, [id]);

export const updateLeads = async (payload: TUpdateLead) => adminRequest.put(`/v0/lead-warehouse-api/leads/${payload.leadId}/${payload.method}/${payload.status}`, payload);

export default {
  get,
  getById,
  getLeadNotes,
  postNotes,
  updateLeads,
  deleteNotes,
  getExport,
};
